"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhrasePronunciationDtoV2 = exports.TokenPronunciationDtoV2 = exports.WordPronunciationDtoV2 = exports.ProsodyDtoV2 = exports.CorrectPronunciationsDtoV2 = exports.PhonemesDtoV2 = void 0;
const PhoneDurationDto = {
    short: 'short',
    normal: 'normal',
    long: 'long',
    superlong: 'superlong',
};
const PauseDto = {
    prohibited: 'prohibited',
    optional: 'optional',
    mandatory: 'mandatory',
};
class PhonemesDtoV2 {
}
exports.PhonemesDtoV2 = PhonemesDtoV2;
class CorrectPronunciationsDtoV2 {
}
exports.CorrectPronunciationsDtoV2 = CorrectPronunciationsDtoV2;
const IntonationDto = {
    falling: 'falling',
    rising: 'rising',
    flat: 'flat',
};
class ProsodyDtoV2 {
}
exports.ProsodyDtoV2 = ProsodyDtoV2;
class WordPronunciationDtoV2 {
}
exports.WordPronunciationDtoV2 = WordPronunciationDtoV2;
class TokenPronunciationDtoV2 {
}
exports.TokenPronunciationDtoV2 = TokenPronunciationDtoV2;
class PhrasePronunciationDtoV2 {
}
exports.PhrasePronunciationDtoV2 = PhrasePronunciationDtoV2;
//# sourceMappingURL=pronunciation.dto.v2.js.map